import { Component } from '@angular/core';
import { MaintenanceDto } from '../shared/model/maintenance.model';
import { MaintenanceService } from '../shared/service/maintenance.service';
import { filterOkMapBody } from '../shared/util/http.utils';
import { ExternalRedirectService } from '../shared/service/external-redirect.service';
import { AuthenticationService } from '../shared/service/authentication.service';
import { AUTH_STORAGE_KEY } from '../shared/constant/constant';
import { LocalCacheService } from '../shared/service/local-cache.service';

@Component({
    selector: 'ddc-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
    standalone: false
})
export class MaintenanceComponent {

  maintenanceMessage: string;

  constructor(
    protected maintenanceService: MaintenanceService,
    protected externalRedirectService: ExternalRedirectService,
    private authenticationService: AuthenticationService,
  ) { }

  ngOnInit(): void {
    this.maintenanceService.getMaintenanceInfos().pipe(filterOkMapBody).subscribe((data: MaintenanceDto) => {
      this.maintenanceMessage = data.message
    })
  }

  redirectToLogin(){
    this.externalRedirectService.triggerLogin()
  }

}
